import React, { useEffect, useState } from "react";
import { AiFillEdit } from "react-icons/ai";
import { useLocation } from "react-router-dom";
import { changeLeadDetails } from "../Apis/apis";

const initalState = {
  name: "", //done
  email: "", //done
  website: "", //done
  phonenumber: "", //done
  company: "", //company
  address: "", //done
  city: "", //city
  state: "", //done
  country: "", //done
  zip: "", //donw
  description: "", //done
  leadstatus: "", //done
  leadsource: "", //done
  lastcontact: "", //lastcontact
  media_path_slug: "", // done
};


// Remove dateassigned and position from initialState
const { dateassigned, position, ...initialStateWithoutDateAndPosition } = initalState;

const EditLead = ({
  model,
  updateLead,
  setLaeds,
  AssignLead,
  leadstatus: statusLead,
  leadSource: stafflist,
}) => {
  const [update, setUpdate] = useState(initialStateWithoutDateAndPosition);

  const locations = useLocation();
  const path = locations.pathname;

  useEffect(() => {
    setUpdate({ ...model });
  }, [model]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setUpdate({ ...update, [name]: value });
  };


  const editLead = async (e) => {
    e.preventDefault();
    const data = await changeLeadDetails(path, update);
    if (data.message === "You are not authorized for this Action") {
      alert(data.message);
      setLaeds(false);
    } else {
      alert(data.message);
      setLaeds(false);
    }
  };

  const {
    name,
    email,
    media_path_slug,
    website,
    phonenumber,
    company,
    address,
    city,
    state,
    country,
    zip,
    description,
    leadstatus,
    leadsource,
    lastcontact,
  } = update;

  return (
    <>
      <div id="profile">
        {updateLead ? (
          <form onSubmit={(e) => editLead(e)}>
            <div className="row">
              <div className="d-flex justify-content-between">
                <div>
                  <label for="leadstatus">Status : </label>
                  <select
                    className="custom-select ms-1"
                    name="leadstatus"
                    value={leadstatus}
                    onChange={handleChange}
                  >
                    <option value={leadstatus}>{leadstatus}</option>
                    {statusLead.map((el) => (
                      <option value={el.name}>{el.name}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label for="leadsource">Source : </label>
                  <select
                    className="custom-select ms-1"
                    id="leadsource"
                    name="leadsource"
                    value={leadsource}
                    onChange={handleChange}
                  >
                    <option disabled={true} selected>
                      {leadsource}
                    </option>

                    {stafflist.map((el) => (
                      <option value={el}>{el}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label for="media_path_slug">Assigned : </label>
                  <select
                    className="custom-select ms-1"
                    id="media_path_slug"
                    value={media_path_slug}
                    name="media_path_slug"
                    onChange={handleChange}
                  >
                    <option disabled={true} selected>
                      {media_path_slug}
                    </option>

                    {AssignLead.map((el) => (
                      <option value={el.media_path_slug}>
                        {el.media_path_slug}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-6  text-start">
                <label for="Name">Name :</label>
                <input
                  className=" form-control mt-1 ms-0"
                  id="Name"
                  name="name"
                  type="text"
                  // placeholder="name"
                  value={name}
                  onChange={handleChange}
                />
                <label for="Address">Address :</label>
                <input
                  className=" form-control mt-1 ms-0"
                  id="Address"
                  name="address"
                  type="text"
                  value={address}
                  // placeholder="Address"
                  onChange={handleChange}
                />
                <label for="Email_Address">Email :</label>
                <input
                  className=" form-control mt-1 ms-0 mb-2"
                  id="Email_Address"
                  type="email"
                  value={email}
                  name="email"
                  // placeholder="email address"
                  onChange={handleChange}
                />
                <label for="Phone">Phone :</label>
                <input
                  className=" form-control mt-1 ms-0"
                  id="Phone"
                  type="number"
                  value={phonenumber}
                  // placeholder="phone number"
                  name="phonenumber"
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 me-0 pe-0 mb-2">
                <label for="City">City :</label>
                <input
                  id="City"
                  type="text"
                  className=" form-control mt-1 ms-0 me-0"
                  name="city"
                  value={city}
                  // placeholder="city"
                  onChange={handleChange}
                />
                <label for="Country">Country :</label>
                <input
                  id="Country"
                  type="text"
                  value={country}
                  className=" form-control mt-1 ms-0"
                  name="country"
                  // placeholder="Country"
                  onChange={handleChange}
                />
                <label for="State">State :</label>
                <input
                  id="State"
                  type="text"
                  value={state}
                  className=" form-control mt-1 ms-0"
                  name="state"
                  // placeholder="State"
                  onChange={handleChange}
                />
                <label for="Zip_Code">Zip_Code :</label>
                <input
                  className=" form-control mt-1 ms-0"
                  id="Zip_Code"
                  type="number"
                  value={zip}
                  name="zip"
                  // placeholder="Zip_Code"
                  onChange={handleChange}
                />
              </div>
              <br className="mt-2" />
              <label for="Company">Company :</label>
              <input
                className=" form-control mt-1"
                id="Company"
                type="text"
                value={company}
                name="company"
                // placeholder="Company"
                onChange={handleChange}
              />
              {/* <label  for="Website">Website </label>
            <input id='Website' type="url" name='website'  placeholder='Website' onChange={handleChange}/> */}
              <label for="Website">Website :</label>
              <input
                id="Website"
                className=" form-control mt-1"
                type="text"
                name="website"
                value={website}
                // placeholder="Website"
                onChange={handleChange}
              />
               <label for="Last_Contact">Last_Contact : </label>
              <input
                id="Last_Contact"
                type="text"
                name="lastcontact"
                className=" form-control mt-1 "
                value={lastcontact}
                // placeholder="Last_Contact"
                onChange={handleChange}
              />
              <label for="Description">Description :</label>
              <input
                id="Description"
                className=" form-control mt-1"
                type="text"
                value={description}
                name="description"
                // placeholder="Description"
                onChange={handleChange}
              />
             
              <div className="d-flex justify-content-center my-2">
                <input className="w-50" type="submit" value="Save" />
              </div>
            </div>
          </form>
        ) : (
          <div className="row">
            <div className="col">
              <strong>Lead Information</strong>
              <div className="d-flex flex-column">
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Name : <span>{(model.name ??= <AiFillEdit />)}</span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Email Address :{" "}
                  <span className="m-1">
                    {(model.email ??= <AiFillEdit />)}
                  </span>{" "}
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  WebSite :{" "}
                  <span className="m-1">
                    {(model.website ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Phone :{" "}
                  <span className="m-1">
                    {(model.phonenumber ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Company :{" "}
                  <span className="m-1">
                    {(model.company ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Address :{" "}
                  <span className="m-1">
                    {(model.address ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  City :{" "}
                  <span className="m-1">{(model.city ??= <AiFillEdit />)}</span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  State :{" "}
                  <span className="m-1">
                    {(model.state ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Country :{" "}
                  <span className="m-1">
                    {(model.country ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Zip-Code :{" "}
                  <span className="m-1">{(model.zip ??= <AiFillEdit />)}</span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Description :{" "}
                  <span
                    className="fs-6 text-secondary m-2 ps-0 ms-0"
                    dangerouslySetInnerHTML={{ __html: model.description }}
                  />
                </h6>
              </div>
            </div>
            <div className="col">
              <strong>General Information</strong>
              <div className="d-flex flex-column">
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Status : <span>{(model.leadstatus ??= <AiFillEdit />)}</span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Source :{" "}
                  <span className="m-1">
                    {(model.leadsource ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Assigned :{" "}
                  <span className="m-1">
                    {(model.media_path_slug ??= <AiFillEdit />)}
                  </span>{" "}
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Created :{" "}
                  <span className="m-1">
                    {(model.dateassigned ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Last Contact :{" "}
                  <span className="m-1">
                    {(model.lastcontact ??= <AiFillEdit />)}
                  </span>
                </h6>
                <h6 className="fs-6 text-secondary m-2 ps-0 ms-0">
                  Public :{" "}
                  <span className="m-1">
                    {(model.is_public ??= <AiFillEdit />)}
                  </span>
                </h6>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EditLead;
